import { render } from "./TeamSectionItem.vue?vue&type=template&id=07bf378d&scoped=true&ts=true"
import script from "./TeamSectionItem.vue?vue&type=script&lang=ts"
export * from "./TeamSectionItem.vue?vue&type=script&lang=ts"

import "./TeamSectionItem.vue?vue&type=style&index=0&id=07bf378d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bf378d"]])

export default __exports__